import { getDateInServerExpectedFormat, nowInCET } from "./helpers";

function getDefaultDates() {
  const today = nowInCET();
  const tenDaysLater = new Date(today);
  tenDaysLater.setDate(today.getDate() + 10);

  return {
    startDate: getDateInServerExpectedFormat(today),
    endDate: getDateInServerExpectedFormat(tenDaysLater),
  };
}

export function buildStaySearchUrl(city = "Sarajevo", type) {
  const { startDate, endDate } = getDefaultDates();
  const baseStay = `start_date=${startDate}&end_date=${endDate}&adults=2&rooms=1`;
  let url = `/stays/search?location=${encodeURIComponent(city)}&${baseStay}`;
  if (type) url += `&types=${type}`;
  return url;
}

export function buildCarSearchUrl(type, yearCat) {
  const { startDate, endDate } = getDefaultDates();
  const baseCar = `location=${encodeURIComponent("Sarajevo Intl Airport SJJ \u2708")}&start_date=${startDate}&end_date=${endDate}&pick_up_time=08%3A30&drop_off_time=18%3A00&adults=2&rooms=1`;
  let url = `/cars/search?${baseCar}`;
  if (type) url += `&types=${type}`;
  if (yearCat) url += `&production_year_category=${yearCat}`;
  return url;
}

export function buildTourBuilderUrl() {
  const { startDate, endDate } = getDefaultDates();
  const baseTour = `start_date=${startDate}&end_date=${endDate}&adults=2`; // &rooms=1 — omitted until tour stay picker needs it
  return `/tours/builder?${baseTour}`;
}
